export default "__VITE_ASSET__4bvmbExc__"